import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getIsBannerVisible } from '@app/redux/ui/selectors';
import { turnOffBanner, turnOnBanner } from '@app/redux/ui/actions';
import { Text, Button, HStack, useDisclosure } from '@stockx/ui';
import { ArrowRightIcon } from '@stockx/icons';
import { useCustomerIsOnVacation } from '@app/user';
import { VacationModeModal } from '@account/pages/AccountSettingsView/components/VacationMode';

const Banner = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isOnVacation = useCustomerIsOnVacation();
  const isBannerOpen = useSelector((state) =>
    getIsBannerVisible(state, 'vacationMode'),
  );

  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    if (isOnVacation && !isBannerOpen) {
      dispatch(turnOnBanner('vacationMode'));
    } else if (!isOnVacation && isBannerOpen) {
      dispatch(turnOffBanner('vacationMode'));
    }
  }, [isOnVacation, isBannerOpen, dispatch]);

  if (!isBannerOpen) {
    return null;
  }

  return (
    <>
      <Button
        width={'100%'}
        onClick={onOpen}
        data-component="VacationMode"
        bg="yellow.100"
        fontSize="16px"
        fontWeight={400}
        _hover={{ bg: 'yellow.100' }}
        rightIcon={<ArrowRightIcon />}
      >
        <HStack as="span" spacing={3}>
          <Text>{t('vacation_mode_banner_text')}</Text>
          <Text variant="medium" textTransform="capitalize">
            {t('vacation_mode_toggle_off')}
          </Text>
        </HStack>
      </Button>
      <VacationModeModal isOpen={isOpen} onClose={onClose} />
    </>
  );
};

export default Banner;
